import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MfaService {
  constructor(protected http: HttpClient) {}

  initiateSetup(): Observable<{ qrCodeImage: string; otpauthUri: string }> {
    return this.http.post<any>('json/mfa/setup/initiate', {});
  }

  completeSetup(code: string, deviceName: string): Observable<any> {
    return this.http.post<any>('json/mfa/setup/complete', {
      code,
      deviceName
    });
  }

  deleteSetup(id: string): Observable<any> {
    return this.http.delete<any>(`json/mfa/remove/${id}`);
  }

  deleteAllSetups(username: string): Observable<any> {
    return this.http.delete<any>(`json/mfa/${username}/delete-all-mfa`);
  }
}
